/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from "react";
import { Oval } from "react-loader-spinner";
import { format_price } from "../../js/utils";
import "../../styles/lkOrders.css"
import { useStores } from "hooks/useStores";
import { deleteAuthCookies } from "utils/Cookie";
import { useNavigate } from 'react-router';
import { ROUTES_PATHS } from 'const';
import { EmptyIcon } from "components/Cards/ProductCard/components/EmptyIcon";

const LkOrders = () => {
  const [orders, setOrders] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [filters, setFilters] = useState([]);
  const [isLoadedItems, setIsLoadedItems] = useState(false);
  const [fetchAll, setFetchAll] = useState(1);

  const { api } = useStores()
  const navigate = useNavigate()

  useEffect(() => {
    setIsLoaded(false);
    api.order.getOrders()
      .then((response) => {
        setOrders(response.orders);
        setFilters(response.filters);
      })
      .then(() => {
        setIsLoaded(true);
        setIsLoadedItems(true);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          deleteAuthCookies()
        }
      });
  }, [fetchAll]);

  const getAllOrders = () => {
    setFetchAll(fetchAll + 1);
  };

  const [orderDate, setOrderDate] = useState([]);
  useEffect(() => {
    if (isLoaded) {
      const monthNames = [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
      ];
      let newArr = [];
      for (let item of orders) {
        let date = item.updated_at.split("T")[0];
        newArr.push(date);
      }

      let arr = [];
      for (let order of newArr) {
        let date = order.split("-")[2];
        if (date.split("")[0] == 0) {
          date = date.split("")[1];
        }
        let orderDetail = `Заказ от ${date} ${
          monthNames[order.split("-")[1] - 1]
        }`;
        arr.push(orderDetail);
      }
      setOrderDate(arr);
    }
  }, [isLoaded]);

  const getFilterOrders = (props) => {
    setIsLoadedItems(false);
    api.order.getOrders({
      year: props.filterYear
    })
      .then((response) => {
        setOrders(response.orders);
      })
      .then(() => setIsLoadedItems(true));
    let tabs = document.querySelectorAll(".lk-orders-tabs__item");
    tabs.forEach((tab) => {
      if (tab) {
        tab.classList.remove("lk-orders-tabs__item-active");
      }
    });
    tabs[props.i + 1].classList.add("lk-orders-tabs__item-active");
  };

  const dropDownItems = (i) => {
    document
      .querySelectorAll(".lk-orders-items-item__arrow")
      [i].classList.toggle("lk-orders-items-item__arrow-open");

    document
      .querySelectorAll(".lk-orders-items-item")
      [i].classList.toggle("lk-orders-items-item-active");
  };

  const repeatOrder = (id) => {
    api.user.postRepeatOrder(id)
      .then((res) => {
        navigate(ROUTES_PATHS.CART)
      })
  };

  return (
    <>
      {isLoaded ? (
        <div className='lk-orders'>
          <div className='lk-orders-tabs'>
            <div
              id='filterAll'
              className='lk-orders-tabs__item lk-orders-tabs__item-active'
              onClick={getAllOrders}
            >
              Все
            </div>
            {filters.map((filter, i) => (
              <div
                key={i}
                id={filter.year}
                className='lk-orders-tabs__item'
                onClick={() => getFilterOrders({ filterYear: filter.year, i })}
              >
                {filter.year}
              </div>
            ))}
          </div>
          {isLoadedItems && (
            <div className='lk-orders-items'>
              {orders.length === 0 ? (
                <div className='lk-orders-empty'>
                  У Вас нет предыдущих заказов
                </div>
              ) : (
                orders?.map((order, i) => (
                  <div key={i} className='lk-orders-items-item'>
                    <div className='lk-orders-items-item-wrap'>
                      <div className='lk-orders-items-item__info'>
                        {/* <h3>Заказ от {order.updated_at.split('T')[0]}</h3> */}
                        <h3>{orderDate[i]}</h3>
                        <h4>
                          № заказа: <span>{order.number}</span>
                        </h4>
                      </div>
                      <div className='lk-orders-items-item__delivery'>
                        <h3>
                          Оформлено:{" "}
                          {order.delivery ? (
                            <span>доставка</span>
                          ) : (
                            <span>самовывоз</span>
                          )}
                        </h3>
                      </div>
                      <div className='lk-orders-items-item__total'>
                        <h3>
                          Сумма заказа: {format_price(order.total_cost)} руб.
                        </h3>
                      </div>
                      <div className='lk-orders-items-item__repeat'>
                        <button onClick={() => repeatOrder(order.id)}>
                          <div />
                          <p>Повторить заказ</p>
                        </button>
                      </div>
                      <div
                        onClick={() => dropDownItems(i)}
                        className='lk-orders-items-item__arrow'
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 10L12 15L17 10H7Z" fill="#222222"/>
                        </svg>
                      </div>
                    </div>
                    <div className='lk-orders-items-item-goods'>
                      <div className='lk-orders-items-item-count'>
                        {" "}
                        Лист товаров ({order.cart_items.length} ед.)
                      </div>
                      {order?.cart_items?.map((item, i) => (
                        <div key={i} className='goods-item'>
                          <div className='item-wrap-lk'>
                            <div className='item-image'>
                              {item.image === null ? 
                                <EmptyIcon minHeight='44px' /> : (
                                <img loading="lazy" 
                                  src={item.image} 
                                  alt={item.title}
                                />
                              )}
                            </div>
                            <div className='item-text'>
                              <p>{item.product_name}</p>
                            </div>
                            <div className='item-counters-registration'>
                              {item.package_quantity === 0 ? (
                                <div className='item-counters-registration item-counters-reg'>
                                  <p>{item.item_quantity} шт.</p>
                                </div>
                              ) : (
                                <div className='item-counters-registration item-counters-reg'>
                                  <p>{item.package_quantity} коробка(ок)</p>
                                  <img loading="lazy"
                                    src='../../../assets/icons/cart-reg-dot.svg'
                                    width='6px'
                                    height='20px'
                                  />
                                  <p>{item.item_quantity} шт.</p>
                                </div>
                              )}
                            </div>
                            <div className='item-price item-price-lk'>
                              <div className='item-price-total'>
                                {format_price(item.total_price)} ₽
                              </div>
                              <div className='item-prices'>
                                <div className='item-price-max'>
                                  {format_price(item.max_price)} ₽/шт.
                                </div>
                                <div className='item-price-perOne'>
                                  {format_price(item.min_price)} ₽/шт.
                                </div>
                              </div>
                            </div>
                          </div>
                          {i + 1 != order.cart_items.length ? (
                            <div className='item-border'></div>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      ) : (
        <div className='lk-orders-loader'>
          <Oval color='#ffd600' height={200} width={200} />
        </div>
      )}
    </>
  );
};

export default LkOrders;
